import gql from 'graphql-tag'
import { fragment } from './getClosing'

export default gql`
mutation updateClosingMoney($id: ID!, $fields: ClosingFieldsMoney) {
    cashAssist {
      updateClosingMoney(id: $id, fields: $fields){
				...getClosingFragment
      }
    }
}
${fragment}`
